import {
    FETCH_UNIT_BEGIN,
    FETCH_UNIT_SUCCESS,
    FETCH_UNIT_FAILURE,
    UPDATE_UNIT_BEGIN,
    CREATE_UNIT_BEGIN,
    CREATE_UNIT_SUCCESS,
    DELETE_UNIT_BEGIN,
    DELETE_UNIT_SUCCESS,
    PUBLISH_TO_JIRA_BEGIN,
    PUBLISH_TO_JIRA_SUCCESS,
    UPDATE_TO_JIRA_BEGIN,
    UPDATE_TO_JIRA_SUCCESS,
    DELETE_FROM_JIRA_BEGIN,
    DELETE_FROM_JIRA_SUCCESS,
    DOWNLOAD_FROM_S3,
    DOWNLOAD_FROM_S3_BEGINS,
    ADD_TO_FAVORITES_BEGIN,
    ADD_TO_FAVORITES_SUCCESS,
    FETCH_MY_CREATIVES_BEGIN,
    FETCH_MY_CREATIVES_SUCCESS
} from '../actions/unitActions';

const initialState = {
    campaign: {},
    input_options: {
        demo_types: [],
        designers: [],
        devices: [],
        functionalities: [],
        creative_types: [],
    },
    unit: {
        demo_links: [],
        functionalities: []
    },
    pagination: {
        page_limit: 0,
        total_pages: 0,
        total_records: 0,
        current_page: 0,
    },
    my_creatives: [],
    verticals: [],
    loading: false,
    message: false,
    error: false,
    jira_url: false,
    delete: false,
    favorite: false,
};

export default function unitReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_UNIT_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errors: [],
                message: false
            };

        case FETCH_UNIT_SUCCESS:
            let permission = "";
                if(action.payload.result === undefined){
                    permission = true;
                }else{
                    permission = action.payload.result.permission;
                }
            return {
                ...state,
                ...action.payload.result,
                loading: false,
                error: false,
                message: false,
                edit:  false,
                favorite: action.payload.result.unit.favorite,
                permission: permission,
                errors: []
            };

        case FETCH_UNIT_FAILURE:
            return {
                ...state,
                loading: false,
                error: false
            };

        case UPDATE_UNIT_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errors: []
            };

        case DELETE_UNIT_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errors: []
            };

        case DELETE_UNIT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                errors: []
            };

        case CREATE_UNIT_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errors: []
            };

        case CREATE_UNIT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                errors: []
            };
        case PUBLISH_TO_JIRA_BEGIN:
            return{
                ...state,
                loading: true,
                message: false
            }
        case PUBLISH_TO_JIRA_SUCCESS:
            return{
                ...state,
                loading: false,
                jira_url: action.payload.url,
                edit:  action.payload.edit,
                message: action.payload.message
            }
        case UPDATE_TO_JIRA_BEGIN:
            return{
                ...state,
                loading: true,
                message: false
            }
        case UPDATE_TO_JIRA_SUCCESS:
            return{
                ...state,
                loading: false,
                jira_url: action.payload.url,
                edit:  action.payload.edit,
                message: action.payload.message
            }
        case DELETE_FROM_JIRA_BEGIN:
            return{
                ...state,
                loading: true,
                delete: true,
                message: false
            }
        case DELETE_FROM_JIRA_SUCCESS:
            return{
                ...state,
                loading: false,
                edit:  false,
                jira_url: "",
                delete: false,
                message: action.payload.message
            }
        case DOWNLOAD_FROM_S3:
            return{
                ...state,
                loading: false,
                message: action.payload
            }
        case DOWNLOAD_FROM_S3_BEGINS:
            return{
                ...state,
                loading: true,
                message: false
            }
        case ADD_TO_FAVORITES_BEGIN:
            return{
                ...state,
                loading: true,
                message: false
            }
        case ADD_TO_FAVORITES_SUCCESS:
            return{
                ...state,
                loading: false,
                favorite: action.payload.favorite_added,
                message: action.payload
            }
        case FETCH_MY_CREATIVES_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
            };

        case FETCH_MY_CREATIVES_SUCCESS:
            return {
                ...state,
                loading: false,
                pagination: action.payload.result.pagination,
                my_creatives: action.payload.result.units,
                favorite: action.payload.result.units.favorite,
                errors: []
            };
        default:
            return state;
    }
}
